module.exports = __webpack_public_path__ + "static/media/142.6fde2b0d.png";